import BlockRichText from './richtext'

export default BlockRichText
